import http from '@/fetch/http'
import Vue from 'vue'
import * as types  from '@/vuex/types'

/**
 * 存储表格题盖章划线信息
 * @type {{}}
 */
const state = {
  // 盖章时选中的章
  selectSign: {
    id: -1
  },

  // 划线时 选中的线
  selectLine: {
    id: -1
  },

  //表格题第几张表单
  tableIndex: 0,
  StampLineModalFlag: false
}

const actions = {
  setSelectSign({commit}, sign){
    commit('SET_SELECT_SIGN', sign);
  },
  setSelectLine({commit}, line){
    commit('SET_SELECT_LINE', line);
  },
  setTableIndex({commit}, index){
    commit('SET_TABLE_INDEX', index);
  },
  //盖章画线 不能弹出input
  StampLineModal({commit},flag) {
    commit('stamplinemodal' ,flag)
  },
}

const getters = {}

const mutations = {
  ['SET_SELECT_SIGN'](state, sign) {
    if(sign == 'cancel'){
      sign = {id:-1};
    }
    Vue.set(state, 'selectSign', sign);
  },
  ['SET_SELECT_LINE'](state, line) {
    if(line == 'cancel'){
      line = {id:-1,isStartPoint: true};
    }
    Vue.set(state, 'selectLine', line);
  },
  ['SET_TABLE_INDEX'](state, index) {
    Vue.set(state, 'tableIndex', index);
  },
  //盖章画线 不能弹出input
  stamplinemodal(state,flag) {
    if(flag == 'close') {
      state.StampLineModalFlag = false;
    } else if(flag == 'open') {
      state.StampLineModalFlag = true;
    }
  }
}

export default {
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/student/table.js